<!--
 * @Author: wuwei
 * @Date: 2025-10-23 08:51:20
 * @LastEditors: wuwei
 * @LastEditTime: 2026-03-23 16:26:44
 * @Description: 
 * Copyright (c) 2026-present HBIS Digital Technology Co.,Ltd. All rights reserved. 
-->
<template>
  <div style="background-color: #c3e2fa;">
    <Header></Header>
    <router-view style="min-height:55.5vh;width: 1200px;margin: 0 auto;" />
    <Footer></Footer>
    <!-- <slogan></slogan> -->
  </div>
</template>

<script>
import Header from "./components/Header.vue"
import Footer from "./components/Footer.vue"
import slogan from "./components/slogan.vue"

export default {
  name: "app",
  components: {
    // index
    Header,
    Footer,
    slogan,
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  min-width: 1200px;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
